import { Component, OnDestroy } from '@angular/core';
import { CredentialType } from 'enums/CredentialType';
import { MessageType } from 'enums/MessageType';
import { UserModel } from 'models/generated/Identity.Api.Models.User';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { TranslatePipe } from 'pipes/translate.pipe';
import { Subscription } from 'rxjs';
import { CredentialRequired } from 'services/credential.service';
import { ComponentUrl, NavigationService, UrlParam } from 'services/navigation.service';
import { NotificationService } from 'services/notification.service';
import { PushService } from 'services/push.service';
import { UserService } from 'services/user.service';
import { ViewUserComponent } from './view-user.component';

@Component({
	selector: 'list-user',
	templateUrl: './list-user.component.html',
	imports: [Layout, ListView, ViewUserComponent, TranslatePipe]
})
@ComponentUrl('list-user')
@CredentialRequired(CredentialType.UsersAccessFull)
export class ListUserComponent implements OnDestroy {

	@UrlParam
	selectedUserId?: string;

	users: UserModel[] = [];
	onUserChanges: Subscription;
	createNewUser = false;

	constructor(private readonly navigation: NavigationService, 
		private readonly pushService: PushService,
		private readonly userService: UserService,
		private readonly notificationService: NotificationService) {

		this.updateUsersList();

		this.onUserChanges = this.pushService.onChanges(MessageType.UserChanges).subscribe(data => {
			this.updateUsersList();
		});
	}

	setSelectedUserId(id?: string) {
		this.selectedUserId = id;
		this.navigation.refreshUrl();
		if (id)
			this.createNewUser = false;
	}

	updateUsersList() {
		this.userService.getAllActiveUsers().then(users => {
			this.users = users;
			if (this.selectedUserId)
				this.setSelectedUserId(users.find(u => u.id == this.selectedUserId)?.id);
		});
	}

	createUser() {
		this.selectedUserId = undefined;
		this.createNewUser = true;
	}

	deleteUser(user: UserModel) {
		this.notificationService.confirm('user.prompt-for-delete', { 'userName': user.name }).subscribe(result => {
			if (result)
				this.userService.deleteUser(user).then(() => this.setSelectedUserId());
		});
	}

	ngOnDestroy() {
		this.onUserChanges.unsubscribe();
	}
}
